import { Injectable } from '@angular/core';
import {ImageService} from "../atoms/image/image.service";

@Injectable({
  providedIn: 'root'
})
export class SessionGeneratedImagesService {

  teacherSidebarSchoolLogo = this.image.getPlaceholderImage();
  constructor(private image: ImageService) { }

  getSchoolAvatar(schoolId: number) {
    const placeHolderDir = "/assets/img/placeholders/";

    let rand = "0" + Math.floor(schoolId % 40);
    if(rand.length === 3) {
      rand = rand.substring(1, 3);
    }

    if(schoolId === 0) {
      rand = "00";
    }

    const imageFileName = "BER_final_Placeholder_Arrow_" + rand + ".svg";

    return {
      huge: {url: placeHolderDir + imageFileName, width: 1000},
      info: {caption: "Bild nicht gefunden", copyright: "Berufsreise.at", alttext: "Bild nicht gefunden"},
      landscape: {url: placeHolderDir + imageFileName, width: 100},
      large: {url: placeHolderDir + imageFileName, width: 700},
      medium: {url: placeHolderDir + imageFileName, width: 500},
      portrait: {url: placeHolderDir + imageFileName, width: 400},
      xlarge: {url: placeHolderDir + imageFileName, width: 1500}
    }
  }

  getClassBackgroundColor(className: string): string {
    const colors = ["yellow", "red", "sea", "river", "clover", "grass", "sky", "rock"];
    let total = 0;
    const length = className.length;
    for(let i = 0; i < length; i++) {
      total+= className.charCodeAt(i);
    }

    return colors[total % 8];

  }


}
